import React from "react";
import moment from "moment";
import { ReactComponent as DangerIcon } from "icons/danger.svg";

const userLabel = (user) =>
  user ? `${user.first_name} ${user.last_name}` : "-";

const PendingRemarkGate = ({
  remark,
  pending_count,
  is_submitting,
  onApprove,
}) => (
  <div className="pending-remark-gate">
    <div className="pending-remark-gate__card">
      <header className="pending-remark-gate__header">
        <div className="icon">
          <DangerIcon />
        </div>
        <h1 className="pending-remark-gate__title">
          Uwaga do potwierdzenia
        </h1>
      </header>

      <div className="pending-remark-gate__body">
        {pending_count > 1 && (
          <p className="pending-remark-gate__counter">
            Pozostało uwag do potwierdzenia: {pending_count}
          </p>
        )}
        <p className="pending-remark-gate__meta">
          <strong>Osoba zgłaszająca:</strong>{" "}
          {userLabel(remark?.reporter)}
        </p>
        <p className="pending-remark-gate__meta">
          <strong>Data:</strong>{" "}
          {remark?.created_at
            ? moment(remark.created_at).format("DD.MM.YYYY HH:mm")
            : "-"}
        </p>
        <div className="pending-remark-gate__content">
          {remark?.content}
        </div>
        <p className="pending-remark-gate__hint">
          Potwierdź zapoznanie się z uwagą, aby kontynuować pracę w
          systemie.
        </p>
      </div>

      <footer className="pending-remark-gate__footer">
        <button
          type="button"
          className="btn btn-green btn-sm"
          disabled={is_submitting}
          onClick={onApprove}>
          {is_submitting
            ? "Potwierdzanie..."
            : "Potwierdzam zapoznanie się z uwagą"}
        </button>
      </footer>
    </div>
  </div>
);

export default PendingRemarkGate;
